let coinMap = new Map([
    [
        "BTC",
        "BTCUSDT"
    ],
    [
        "ETH",
        "ETHUSDT"
    ],
    [
        "USDT",
        "USDTUSDT"
    ],
    [
        "BNB",
        "BNBUSDT"
    ],
    [
        "USDC",
        "USDCUSDT"
    ],
    [
        "XRP",
        "XRPUSDT"
    ],
    [
        "ADA",
        "ADAUSDT"
    ],
    [
        "DOGE",
        "DOGEUSDT"
    ],
    [
        "LTC",
        "LTCUSDT"
    ],
    [
        "SOL",
        "SOLUSDT"
    ],
    [
        "TRX",
        "TRXUSDT"
    ],
    [
        "DOT",
        "DOTUSDT"
    ],
    [
        "MATIC",
        "MATICUSDT"
    ],
    [
        "BCH",
        "BCHUSDT"
    ],
    [
        "AVAX",
        "AVAXUSDT"
    ],
    [
        "SHIB",
        "SHIBUSDT"
    ],
    [
        "DAI",
        "USDTDAI"
    ],
    [
        "UNI",
        "UNIUSDT"
    ],
    [
        "BUSD",
        "BUSDUSDT"
    ],
    [
        "LINK",
        "LINKUSDT"
    ],
    [
        "XMR",
        "XMRUSDT"
    ],
    [
        "TUSD",
        "TUSDUSDT"
    ],
    [
        "ATOM",
        "ATOMUSDT"
    ],
    [
        "XLM",
        "XLMUSDT"
    ],
    [
        "ETC",
        "ETCUSDT"
    ],
    [
        "FIL",
        "FILUSDT"
    ],
    [
        "ICP",
        "ICPUSDT"
    ],
    [
        "LDO",
        "LDOUSDT"
    ],
    [
        "APT",
        "APTUSDT"
    ],
    [
        "HBAR",
        "HBARUSDT"
    ],
    [
        "QNT",
        "QNTUSDT"
    ],
    [
        "VET",
        "VETUSDT"
    ],
    [
        "NEAR",
        "NEARUSDT"
    ],
    [
        "GRT",
        "GRTUSDT"
    ],
    [
        "AAVE",
        "AAVEUSDT"
    ],
    [
        "STX",
        "STXUSDT"
    ],
    [
        "USDP",
        "USDPUSDT"
    ],
    [
        "ALGO",
        "ALGOUSDT"
    ],
    [
        "EGLD",
        "EGLDUSDT"
    ],
    [
        "FTM",
        "FTMUSDT"
    ],
    [
        "MKR",
        "MKRUSDT"
    ],
    [
        "OP",
        "OPUSDT"
    ],
    [
        "SAND",
        "SANDUSDT"
    ],
    [
        "EOS",
        "EOSUSDT"
    ],
    [
        "APE",
        "APEUSDT"
    ],
    [
        "XTZ",
        "XTZUSDT"
    ],
    [
        "IMX",
        "IMXUSDT"
    ],
    [
        "THETA",
        "THETAUSDT"
    ],
    [
        "RPL",
        "RPLUSDT"
    ],
    [
        "MANA",
        "MANAUSDT"
    ],
    [
        "AXS",
        "AXSUSDT"
    ],
    [
        "SNX",
        "SNXUSDT"
    ],
    [
        "FLOW",
        "FLOWUSDT"
    ],
    [
        "CRV",
        "CRVUSDT"
    ],
    [
        "NEO",
        "NEOUSDT"
    ],
    [
        "XEC",
        "XECUSDT"
    ],
    [
        "KLAY",
        "KLAYUSDT"
    ],
    [
        "GMX",
        "GMXUSDT"
    ],
    [
        "LUNC",
        "LUNCUSDT"
    ],
    [
        "MINA",
        "MINAUSDT"
    ],
    [
        "FXS",
        "FXSUSDT"
    ],
    [
        "BTT",
        "BTTCUSDT"
    ],
    [
        "CFX",
        "CFXUSDT"
    ],
    [
        "DASH",
        "DASHUSDT"
    ]
]);
module.exports = coinMap;